const featureTestimonialBlocks = document.querySelectorAll(
    ".homepage-testimonials"
);

featureTestimonialBlocks.forEach((featureTestimonials) => {
    const blocks: null | NodeListOf<HTMLElement> =
        featureTestimonials.querySelectorAll(".testimonial-block");
    const loadMoreButton: HTMLButtonElement =
        featureTestimonials.querySelector(".js-load-more");

    document.addEventListener("DOMContentLoaded", async () => {
        await initMasonry();
        await figureOutRows();
    });

    function initMasonry() {
        if (window.innerWidth > 980) {
            blocks[0].parentElement.classList.remove("initialized");
            blocks.forEach((block) => {
                block.classList.value = "testimonial-block splide__slide";
                block.setAttribute(
                    "data-height",
                    Math.ceil(block.offsetHeight / 15).toString()
                );
                block.setAttribute(
                    "style",
                    "--numRows: " + (Number(block.dataset.height) + 5)
                );
            });
            blocks[0].parentElement.classList.add("initialized");
        }
    }
    function figureOutRows() {
        if (window.innerWidth > 980) {
            const firstRowOffset: number = blocks[0].offsetTop;
            let showLoadMore = false;
            let blocksPerRow: number = 0;
            blocks.forEach((block) => {
                if (block.offsetTop == firstRowOffset) {
                    block.classList.add("first-row");
                    blocksPerRow++;
                }
            });
            for (let x = blocksPerRow; x < blocks.length; x++) {
                if (x < blocksPerRow * 2) {
                    blocks[x].classList.add("second-row");
                    showLoadMore = true;
                } else {
                    blocks[x].classList.add("hidden");
                }
            }
            if (showLoadMore) {
                loadMoreButton.parentElement.classList.add("visible");
            } else {
                loadMoreButton.parentElement.classList.remove("visible");
            }
        }
    }

    window.addEventListener("resize", async () => {
        await initMasonry();
        await figureOutRows();
    });
    loadMoreButton.addEventListener("click", () => {
        let showLoadMore = false;
        let secondRowCount: number =
            featureTestimonials.querySelectorAll(".second-row").length;
        blocks.forEach((block) => {
            if (block.classList.contains("second-row")) {
                block.classList.remove("second-row");
                block.classList.add("first-row");
            }
            if (secondRowCount > 0 && block.classList.contains("hidden")) {
                block.classList.remove("hidden");
                block.classList.add("second-row");
                secondRowCount--;
                showLoadMore = true;
            }
        });
        if (showLoadMore) {
            loadMoreButton.parentElement.classList.add("visible");
        } else {
            loadMoreButton.parentElement.classList.remove("visible");
        }
    });
});
